<template>
  <div id="mapcont">
    <div id="map">
      <!--<test v-if="isMap" v-for="athlete in athletes" :key="athlete.id" :athlete="athlete" :map=map></test>-->
    </div>
    <router-view :key="$route.path"></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MarkerWithLabel from '@google/markerwithlabel'
/* global google */

var checkpointIcon = {
  url: 'https://d3nv7i3620sxr0.cloudfront.net/img/icon-map-timepoint.png'
}

var finishIcon = {
  url: 'https://d3nv7i3620sxr0.cloudfront.net/img/icon-map-finish.png'
}

var athleteIconF = {
  url: 'https://d3nv7i3620sxr0.cloudfront.net/img/icon-map-female.png'
}

var athleteFavIconF = {
  url: 'https://d3nv7i3620sxr0.cloudfront.net/img/icon-map-favourite-female.png'
}

var selectedAthleteIconF = {
  url: 'https://d3nv7i3620sxr0.cloudfront.net/img/icon-map-female-selected.png'
}

var athleteIconM = {
  url: 'https://d3nv7i3620sxr0.cloudfront.net/img/icon-map-male.png'
}

var athleteFavIconM = {
  url: 'https://d3nv7i3620sxr0.cloudfront.net/img/icon-map-favourite-male.png'
}

var selectedAthleteIconM = {
  url: 'https://d3nv7i3620sxr0.cloudfront.net/img/icon-map-male-selected.png'
}
import test from './map/test'

export default{
  components: {
    test: test
  },
  data () {
    return {
      map: null,
      route: null,
      athletePath: null,
      cpmarkers: [],
      cplisteners: [],
      athletemarkers: {},
      selected: '',
      icons: {},
      firebaseRefs: [],
      showFavs: false,
    }
  },
  computed: {
    ...mapGetters({
      mobile: 'mobile',
      searchTerm: 'search',
      checkpoints: 'checkpoints',
      favourites: 'favourites',
      athletes: 'athletes',
      athlete: 'athlete',
      polyline: 'routePolyline',
      raceId: 'raceId',
      race: 'race',
      selectedCat: 'selectedCat'
    }),
    isMap() {
      return typeof this.map !== 'undefined' && this.map !== null;
    }
  },
  watch: {
    raceId: function () {
      if (this.map !== null) {
        this.clearRoute()
        this.clearAthleteMarkers()
      }
    },
    searchTerm: function(term) {
      this.filterMarkers()
    },
    checkpoints: function (cp) {
      this.setRaceCheckpoints()
    },
    athletes: function (newAths, oldAths) {
      if (this.map !== null) {
        this.setAthlete()
      }
    }, deep: true,
    athlete: function(athlete) {
        if(this.map) {
            if(this.athletePath) this.athletePath.setMap(null)
            this.athletePath = null
            if(athlete.fixes) {
                let pos = athlete.fixes.map((fix) => {
                    return {lat: fix.latitude, lng: fix.longitude}
                })
                this.athletePath = new google.maps.Polyline({
                    path: pos,
                    geodesic: true,
                    strokeColor: '#185371',
                    strokeOpacity: 1.0,
                    strokeWeight: 1.5
                });
                this.athletePath.setMap(this.map)
            }
        }
    },
    polyline: function() {
      if (this.map !== null) {
        this.clearRoute()
        // this.clearAthleteMarkers()
      }
      this.setMapRoute()
    },
    favourites: function () {
      //TODO optimize to only set the new favourites or remove favourite
      if (this.map !== null) {
        this.setAthlete()
      }
      if(this.showFavs) {
        this.filterFavourites(this.showFavs)
      }
    },
    '$route': function (value) {
      if (value.name === 'athlete') {
        this.selected = value.params.id
      } else {
        this.selected = value.name
      }
      if (this.map !== null) {
        this.setAthlete()
      }
    },
    showFavs: function () {
      this.filterFavourites(this.showFavs)
    },
    selectedCat: function () {
      this.filterSelectedCat()
    },
  },
  methods: {
    filterMarkers: function() {
        let searchRegex = new RegExp(this.searchTerm, 'i')
        for (let marker in this.athletemarkers) {
            if (searchRegex.test(this.athletemarkers[marker].athName)) {
                this.athletemarkers[marker].setVisible(true)
            } else {
                this.athletemarkers[marker].setVisible(false)
            }
        }
    },
    filterFavourites: function(showFavs) {
      if(showFavs) {
        for (let marker in this.athletemarkers) {
          if(this.favourites.includes(this.athletemarkers[marker].athId)) {
            this.athletemarkers[marker].setVisible(true)
          }
          else {
            this.athletemarkers[marker].setVisible(false)
          }
        }
      } else {
        for (let marker in this.athletemarkers) {
          this.athletemarkers[marker].setVisible(true)
        }
      }
    },
    filterSelectedCat: function() {
      if (this.selectedCat === 'All Categories') {
        for (let marker in this.athletemarkers) {
          this.athletemarkers[marker].setVisible(true)
        }
      } else {
        for (let marker in this.athletemarkers) {
          if(this.athletemarkers[marker].athCat === this.selectedCat) {
            this.athletemarkers[marker].setVisible(true)
          } else {
            this.athletemarkers[marker].setVisible(false)
          }
        }
      }
    },
    createMap: function () {
      if (typeof (google) === 'undefined') {
        setTimeout(this.createMap, 100)
        return
      } else {
        var position = google.maps.ControlPosition.RIGHT_TOP
        var fullscreenControlPosition
        if (this.mobile) {
          // https://developers.google.com/maps/documentation/javascript/controls
          position = google.maps.ControlPosition.RIGHT_BOTTOM
          fullscreenControlPosition = google.maps.ControlPosition.RIGHT_BOTTOM
        }

        const styles = {
          default: [],
          hide: [
            {
              featureType: "poi",
              stylers: [{ visibility: "off" }],
            },
            {
              featureType: "transit",
              elementType: "labels.icon",
              stylers: [{ visibility: "off" }],
            },
          ],
        };

        var mapOptions = {
          styles: styles.hide,
          center: {
            lat: -29.62319,
            lng: 28.2334698
          },
          zoom: 7,
          scaleControl: true,
          // gestureHandling: 'greedy',
          mapTypeControl: true,
          mapTypeControlOptions: {
            position: google.maps.ControlPosition.RIGHT_TOP,
            style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
            mapTypeIds: ['terrain', 'satellite', 'styled_map'] // https://developers.google.com/maps/documentation/javascript/examples/maptype-styled-simple
          },
          mapTypeId: google.maps.MapTypeId.TERRAIN,
          panControl: false,
          zoomControl: true,
          zoomControlOptions: {
            style: google.maps.ZoomControlStyle.SMALL,
            position: position
          },
          streetViewControl: false,
          overviewMapControl: false,
          fullscreenControl: false,
          fullscreenControlOptions: {
            position: fullscreenControlPosition
          },
        }
        this.map = new google.maps.Map(document.getElementById('map'), mapOptions)
        // TODO removing this for now as it will be resolved later

        let TILE_URL = 'http://a.tile.opentopomap.org/{z}/{x}/{y}.png'
        let layer = new google.maps.ImageMapType({
          name: 'Open topo',
          getTileUrl: function (coord, zoom) {
            var url = TILE_URL
              .replace('{x}', coord.x)
              .replace('{y}', coord.y)
              .replace('{z}', zoom)
            return url
          },
          tileSize: new google.maps.Size(256, 256),
          minZoom: 7,
          maxZoom: 17
        })
        this.map.mapTypes.set('styled_map', layer)

        this.map.setOptions('styles', styles.hide)

        this.setMapRoute()
        this.setRaceCheckpoints()

        const centerControlDiv = document.createElement("div");
        this.filterControl(centerControlDiv, this.map)
        this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(centerControlDiv);

        setTimeout(this.setAthlete, 500)
      }
    },
    clearRoute: function () {
      if (this.route != null) {
        this.route.setMap(null)
      }
      this.route = null
    },
    clearAthleteMarkers: function () {
      for (let key in this.athletemarkers) {
        this.athletemarkers[key].setMap(null)
      }
      for (var i = 0; i < this.firebaseRefs.length; i++) {
        let ref = this.firebaseRefs[i].ref
        let onValueChange = this.firebaseRefs[i].onValueChange
        ref.off('value', onValueChange)
      }
      this.firebaseRefs = []
      this.athletemarkers = {}
    },
    setMapRoute: function (rid) {
      if (this.race.type !== "no_route") {
        this.route = new google.maps.KmlLayer({
          url: 'https://app.sportraxs.com/api/tracking/races/' + this.raceId + '/route?type=kml&t=' + (Math.round((new Date()).getTime() / 1000)),
          zIndex: 1000
        })
        this.route.setMap(this.map)

        if(this.race.id == 802) {
          const carroute = new google.maps.KmlLayer({
            url: 'https://app.sportraxs.com/api/tracking/races/' + '804' + '/route?type=kml&t=' + (Math.round((new Date()).getTime() / 1000)),
            zIndex: 1000
          })
          carroute.setMap(this.map)
        }
      }
    },
    setRaceCheckpoints: function () {
      this.clearMarkersMap()
      var bounds = new google.maps.LatLngBounds();
      for (let i in this.checkpoints) {
        if (typeof (this.checkpoints[i].point) !== 'undefined') {
          var myLatlng = new google.maps.LatLng(parseFloat(this.checkpoints[i].point.latitude), parseFloat(this.checkpoints[i].point.longitude))
          var iconImage
          if (!this.checkpoints[i].isFinish) {
            iconImage = checkpointIcon
            iconImage.scaledSize = new google.maps.Size(18, 22)
          } else {
            iconImage = finishIcon
            iconImage.anchor = new google.maps.Point(0, 22)
            iconImage.scaledSize = new google.maps.Size(22, 22)
          }
          var marker = new google.maps.Marker({
            position: myLatlng,
            icon: iconImage,
            map: this.map,
            optimized: false
          })
          this.cpmarkers.push(marker)
          this.setupCPListener(marker, this.checkpoints[i].id)
          bounds.extend(myLatlng)
        }
      }
      if(!bounds.isEmpty()) {
          this.map.fitBounds(bounds)
      }
    },
    setAthletePosition: function (ath, geometry) {
      let cpTimestamp = 0
      if (typeof (this.athletes[ath].lastCP) !== 'undefined') {
        cpTimestamp = this.athletes[ath].lastCP
      }
      let myLatlng
      if (cpTimestamp > geometry.timestamp) {
        myLatlng = new google.maps.LatLng(this.athletes[ath].lastCPgeometry.coordinates[1], this.athletes[ath].lastCPgeometry.coordinates[0])
      } else {
        myLatlng = new google.maps.LatLng(geometry.coordinates[1], geometry.coordinates[0])
      }
      //
    },
    filterControl(controlDiv, map) {
      // Set CSS for the control border.
      const controlUI = document.createElement("div");

      controlUI.style.backgroundColor = "#fff";
      controlUI.style.border = "2px solid #fff";
      controlUI.style.borderRadius = "3px";
      controlUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
      controlUI.style.cursor = "pointer";
      controlUI.style.marginTop = "10px";
      controlUI.style.textAlign = "center";
      controlUI.style.marginLeft = '12px'
      controlDiv.appendChild(controlUI);

      // Set CSS for the control interior.
      const controlText = document.createElement("div");

      controlText.style.color = "rgb(25,25,25)";
      controlText.style.fontFamily = "Roboto,Arial,sans-serif";
      controlText.style.fontSize = "12px";
      controlText.style.lineHeight = "28px";
      controlText.style.paddingLeft = "5px";
      controlText.style.paddingRight = "5px";
      controlText.style.width = '100px';
      controlText.innerHTML = this.showFavs ? 'All' : 'Favourites';
      controlUI.appendChild(controlText);
      // Setup the click event listeners: simply set the map to Chicago.
      controlUI.addEventListener("click", () => {
        this.showFavs = !this.showFavs
        controlText.innerText = this.showFavs ? 'All' : 'Favourites'
      });
    },
    setAthleteFirebaseListener (ath) {
      // let self = this
      // let imei = this.athletes[ath].imei
      // // let ref = db.ref('device_fixes/d' + imei + '/geometry')
      // let onValueChange = ref.on('value', function (snap) {
      //   if (snap.val()) { // Only set the coordinates if not null.
      //     self.setAthletePosition(ath, snap.val())
      //   }
      // })
      // this.firebaseRefs.push({ ref: ref, val: onValueChange })
    },
    setAthlete: function () {
      for (let i in this.athletes) {
        if (!this.athletes[i].isFinished && this.athletes[i].withdrawn_at === null) {
          if (typeof (this.athletes[i].properties) !== 'undefined') {
            var myLatlng
            if (typeof (this.athletes[i].properties.latitude) !== 'undefined') {
              myLatlng = new google.maps.LatLng(this.athletes[i].properties.latitude, this.athletes[i].properties.longitude)
            }
            var marker
            if (this.athletes[i].id === this.selected) {
              // Athlete is selected.
              marker = {
                url: this.athletes[i].gender === 'male' ? selectedAthleteIconM.url : selectedAthleteIconF.url,
                anchor: new google.maps.Point(25, 25),
                scaledSize: new google.maps.Size(50, 50)
              }
            } else if (this._.indexOf(this.favourites, this.athletes[i].id) >= 0) {
              marker = {
                url: this.athletes[i].gender === 'male' ? athleteFavIconM.url : athleteFavIconF.url,
                anchor: new google.maps.Point(10, 10),
                scaledSize: new google.maps.Size(20, 20)
              }
            } else {
              marker = {
                url: this.athletes[i].gender === 'male' ? athleteIconM.url : athleteIconF.url,
                anchor: new google.maps.Point(10, 10),
                scaledSize: new google.maps.Size(20, 20)
              }
            }
            if (typeof (this.athletemarkers[i]) === 'undefined') {
              let name = this.athletes[i].team_id === null ? this.athletes[i].first_name + ' ' + this.athletes[i].last_name : this.athletes[i].team.name
              this.athletemarkers[i] = new MarkerWithLabel({
                position: myLatlng,
                athName: this.athletes[i].first_name + ' ' + this.athletes[i].last_name,
                athId: this.athletes[i].id,
                athCat: this.athletes[i].category,
                icon: marker,
                map: this.map,
                optimized: false,
                labelContent: name,
                labelAnchor: new google.maps.Point(-8, 21),
                labelClass: 'labels'
              })
              // Set firebase listener for specific athlete
              // this.setAthleteFirebaseListener(i)
            } else {
              if (typeof (myLatlng) !== 'undefined' && typeof (marker) !== 'undefined') {
                this.athletemarkers[i].setIcon(marker)
                this.athletemarkers[i].setPosition(myLatlng);
              }
            }
            this.setupAthleteListener(this.athletemarkers[i], this.athletes[i].id)
          }
        } else {
          if (typeof (this.athletemarkers[i]) !== 'undefined') {
            this.athletemarkers[i].setMap(null)
          }
        }
      }
    },
    clearMarkersMap: function () {
      for (let i = 0; i < this.cpmarkers.length; i++) {
        google.maps.event.removeListener(this.cplisteners[i])
        this.cpmarkers[i].setMap(null)
      }
      this.cpmarkers = []
    },
    setupCPListener (marker, number) {
      var self = this
      let eventListener = google.maps.event.addListener(marker, 'click', function (e) {
        self.$ma.trackEvent({action: 'MAP CLICK CHECKPOINT', properties: {'athlete_id' : number, 'event_id': '31'}})
        if (self.mobile) {
          self.$router.push({name: 'mcheckpoint', params: { id: number }})
        } else {
          self.$router.push({name: 'checkpoint', params: { id: number }})
        }
        self.$store.dispatch('focusCP', number)
      })
      this.cplisteners.push(eventListener)
    },
    setupAthleteListener (marker, number) {
      var self = this
      let eventListener = google.maps.event.addListener(marker, 'click', function (e) {
        self.$ma.trackEvent({action: 'MAP CLICK ATHLETE', properties: {'athlete_id' : number, 'event_id': '31'}})
        if (self.mobile) {
          self.$router.push({name: 'mapathlete', params: { id: number }})
        } else {
          self.$router.push({name: 'athlete', params: { id: number }})
        }
      })
      this.cplisteners.push(eventListener)
    }
  },
  mounted () {
    this.createMap()
  }
}
</script>
<style>
  #mapcont {
    flex: 1 1;
    display: flex;
    position: relative;
  }
  #map {
    flex: 1;
  }
  .labels {
    color: #fff;
    background-color: rgba(36, 47, 54, 0.95);
    border: 1px solid black;
    border-radius: 4px;
    padding: 1px;
    font-family: "Lucida Grande", "Arial", sans-serif;
    font-size: 10px;
    text-align: center;
    white-space: nowrap;
  }
  .cplabels {
    color: #000000;
    background-color: rgba(255, 255, 255, 0.46);
    border: 1px solid black;
    border-radius: 4px;
    padding: 1px;
    font-family: "Lucida Grande", "Arial", sans-serif;
    font-size: 10px;
    text-align: center;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/gmap.vue